import React, { useEffect, useRef, useState } from "react";
import { decorateOne } from "../lib/prizeAssets";

const W = 250, H = 150, THRESHOLD = 0.55;

/**
 * Carte à gratter (canvas). Le lot est déjà décidé par le serveur ;
 * ici on ne fait que révéler : on gratte le vernis (destination-out),
 * et à ~55% gratté on découvre le lot et on appelle onReveal().
 */
export default function ScratchCard({ prize, onReveal }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const revealedRef = useRef(false);
  const [revealed, setRevealed] = useState(false);
  const deco = decorateOne(prize.label);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const g = ctx.createLinearGradient(0, 0, W, H);
    g.addColorStop(0, "#d7dce2"); g.addColorStop(0.4, "#98a0aa");
    g.addColorStop(0.55, "#eef1f4"); g.addColorStop(0.8, "#a7aeb8"); g.addColorStop(1, "#c9ced5");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = "#5a626d";
    ctx.font = "800 20px system-ui, sans-serif";
    ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.fillText("GRATTE ICI ✨", W / 2, H / 2 - 8);
    ctx.font = "600 12px system-ui, sans-serif";
    ctx.fillStyle = "#7d858f";
    ctx.fillText("avec ton doigt", W / 2, H / 2 + 14);
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return { x: (p.clientX - r.left) * (W / r.width), y: (p.clientY - r.top) * (H / r.height) };
  };

  const scratch = (e) => {
    if (!drawing.current || revealedRef.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.globalCompositeOperation = "destination-out";
    ctx.beginPath();
    ctx.arc(x, y, 20, 0, Math.PI * 2);
    ctx.fill();
  };

  const checkCleared = () => {
    if (revealedRef.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const data = ctx.getImageData(0, 0, W, H).data;
    let clear = 0, total = 0;
    for (let i = 3; i < data.length; i += 40) { total++; if (data[i] === 0) clear++; }
    if (total && clear / total >= THRESHOLD) {
      revealedRef.current = true;
      setRevealed(true);
      // efface complètement le vernis puis remonte le résultat
      ctx.clearRect(0, 0, W, H);
      setTimeout(() => onReveal && onReveal(), 550);
    }
  };

  const start = (e) => { drawing.current = true; scratch(e); };
  const end = () => { drawing.current = false; checkCleared(); };

  return (
    <div
      data-testid="scratch-surface"
      style={{ position: "relative", width: W, height: H, margin: "12px auto", borderRadius: 12, overflow: "hidden", boxShadow: "inset 0 0 0 2px rgba(226,6,19,.12)" }}
    >
      {/* Lot révélé (dessous) */}
      <div style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", textAlign: "center", background: "#fff7ec", padding: "0 16px" }}>
        {deco.img
          ? <img src={deco.img} alt="" style={{ width: 62, height: 62, objectFit: "contain" }} />
          : <div style={{ fontSize: 40 }}>{deco.emoji}</div>}
        <b style={{ display: "block", color: "#E20613", fontFamily: "system-ui", fontWeight: 800, fontSize: 15, lineHeight: 1.15, marginTop: 4 }}>{prize.label}</b>
      </div>
      {/* Vernis à gratter (dessus) */}
      <canvas
        ref={canvasRef}
        width={W}
        height={H}
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", touchAction: "none", cursor: "grab", opacity: revealed ? 0 : 1, transition: "opacity .5s" }}
        onMouseDown={start} onMouseMove={scratch} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={scratch} onTouchEnd={end}
      />
    </div>
  );
}
